
import { api } from "../api";

/**
 * updateDriverStatusById - Function that updates on database an existing driver status by id   
 * /drivers/{customerId}/{departmentId}/{id}/{status}  
 * method PUT 
 * @async-function
 */
const updateDriverStatusById = async (token: string, id: number, customerId: number, status: string) => {
    const response = await api.put(
        `/drivers/${customerId}/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
    });
    return response;
};
export default updateDriverStatusById;
